import React from "react"
import ReactDisqusComments from 'react-disqus-comments';
export default() => (
    <>
<ReactDisqusComments
    shortname="memecollections"
    // identifier={post.id}
    // title={post.title}
    // url={post.url}
    // category_id={post.category_id}
    onNewComment={() => alert('new comment available!')}
/>
</>
)